import { defineMessages } from "react-intl";

const messages = defineMessages({
  addToExisting: {
    id: "routes.moveStops.addToExisting",
    defaultMessage: "Add to existing",
    description: "Add-to-existing tab",
  },
  allSkippedCopy: {
    id: "routes.moveStops.allSkippedCopy",
    defaultMessage:
      "{count, plural, one {The selected stop is} other {All # selected stops are}} already on {routeName} — nothing was copied",
    description: "All-skipped (copy)",
  },
  allSkippedMove: {
    id: "routes.moveStops.allSkippedMove",
    defaultMessage:
      "{count, plural, one {The selected stop is} other {All # selected stops are}} already on {routeName} — nothing was moved",
    description: "All-skipped (move)",
  },
  back: { id: "routes.moveStops.back", defaultMessage: "Back", description: "Step 2 back" },
  concurrentChange: {
    id: "routes.moveStops.concurrentChange",
    defaultMessage: "Something changed during the transfer. Refresh and try again.",
    description:
      "Move-stops wizard — error when the route changed concurrently (HTTP 409) during the transfer",
  },
  copiedSuccess: {
    id: "routes.moveStops.copiedSuccess",
    defaultMessage: "{count, plural, one {# stop} other {# stops}} copied to {routeName}",
    description: "Copy success",
  },
  copying: {
    id: "routes.moveStops.copying",
    defaultMessage: "Copying…",
    description: "Submit while copying",
  },
  createDisabled: {
    id: "routes.moveStops.createDisabled",
    defaultMessage: "You don't have permission to create routes",
    description: "Create-new tab disabled tooltip",
  },
  createNew: {
    id: "routes.moveStops.createNew",
    defaultMessage: "Create new",
    description: "Create-new tab",
  },
  failure: {
    id: "routes.moveStops.failure",
    defaultMessage: "Couldn't move the stops. Please try again.",
    description: "Generic transfer failure",
  },
  forbiddenCopyExisting: {
    id: "routes.moveStops.forbiddenCopyExisting",
    defaultMessage: "You don't have permission to modify the destination route.",
    description:
      "Move-stops wizard — error when the user lacks permission to modify the destination route when copying to an existing route (HTTP 403)",
  },
  forbiddenCopyNew: {
    id: "routes.moveStops.forbiddenCopyNew",
    defaultMessage: "You don't have permission to create a route.",
    description: "403 copy→new",
  },
  forbiddenMoveExisting: {
    id: "routes.moveStops.forbiddenMoveExisting",
    defaultMessage: "You don't have permission to modify the source or destination route.",
    description: "403 move→existing",
  },
  forbiddenMoveNew: {
    id: "routes.moveStops.forbiddenMoveNew",
    defaultMessage: "You don't have permission to create a route or modify the source route.",
    description: "403 move→new",
  },
  geocodeNotFound: {
    id: "routes.moveStops.geocodeNotFound",
    defaultMessage: "We couldn't find that starting location. Please pick a valid address.",
    description: "Geocode failure",
  },
  movedSuccess: {
    id: "routes.moveStops.movedSuccess",
    defaultMessage: "{count, plural, one {# stop} other {# stops}} moved to {routeName}",
    description: "Move success",
  },
  moving: {
    id: "routes.moveStops.moving",
    defaultMessage: "Moving…",
    description: "Submit while moving",
  },
  next: { id: "routes.moveStops.next", defaultMessage: "Next", description: "Step 1 next" },
  removeFromSource: {
    id: "routes.moveStops.removeFromSource",
    defaultMessage: "Remove these stops from current route",
    description: "Move vs copy toggle",
  },
  removeFromSourceLocked: {
    id: "routes.moveStops.removeFromSourceLocked",
    defaultMessage: "You can't modify this route, so stops will be copied",
    description: "Disabled move toggle tooltip",
  },
  routeLabel: {
    id: "routes.moveStops.routeLabel",
    defaultMessage: "Route",
    description: "Destination segmented label",
  },
  routeName: {
    id: "routes.moveStops.routeName",
    defaultMessage: "Route name",
    description: "Create-new: route name field label",
  },
  rowNoUpdate: {
    id: "routes.moveStops.rowNoUpdate",
    defaultMessage: "You don't have permission to modify this route",
    description: "Row disabled — no update perm",
  },
  rowOverCapacity: {
    id: "routes.moveStops.rowOverCapacity",
    defaultMessage: "Moving these stops would exceed this route's capacity ({max} max)",
    description: "Row disabled — capacity",
  },
  searchRoutes: {
    id: "routes.moveStops.searchRoutes",
    defaultMessage: "Search routes",
    description: "Step 2B search placeholder",
  },
  searchStops: {
    id: "routes.moveStops.searchStops",
    defaultMessage: "Search stops",
    description: "Step 1 search placeholder",
  },
  selectAllIncomplete: {
    id: "routes.moveStops.selectAllIncomplete",
    defaultMessage: "Select all incomplete ({count})",
    description: "Select-all-incomplete checkbox",
  },
  skippedCopy: {
    id: "routes.moveStops.skippedCopy",
    defaultMessage:
      "{count, plural, one {# stop was} other {# stops were}} already on the destination route — skipped",
    description: "Skipped (copy) line",
  },
  skippedMove: {
    id: "routes.moveStops.skippedMove",
    defaultMessage:
      "{count, plural, one {# stop was} other {# stops were}} already on the destination route — left on this route",
    description: "Skipped (move) line",
  },
  startDateTime: {
    id: "routes.moveStops.startDateTime",
    defaultMessage: "Start date and time",
    description: "Create-new: combined start date + time field label",
  },
  startingLocation: {
    id: "routes.moveStops.startingLocation",
    defaultMessage: "Starting location",
    description: "Create-new: starting location field label",
  },
  stepOf: {
    id: "routes.moveStops.stepOf",
    defaultMessage: "Step {current} of {total}",
    description: "Wizard step indicator sub-label",
  },
  stopsCount: {
    id: "routes.moveStops.stopsCount",
    defaultMessage: "{count, plural, one {# stop} other {# stops}}",
    description: "Route row stop count",
  },
  submit: { id: "routes.moveStops.submit", defaultMessage: "Submit", description: "Step 2 submit" },
  title: {
    id: "routes.moveStops.title",
    defaultMessage: "Move Stops",
    description: "Move Stops wizard title",
  },
  view: {
    id: "routes.moveStops.view",
    defaultMessage: "View",
    description: "View destination button",
  },
});

export default messages;
